import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

const EmptyState = ({ icon: Icon, title, description, action, className }) => (
	<div className={twMerge('flex flex-col items-center px-4 py-10 text-center', className)}>
		{Icon && (
			<div className="mb-3 flex h-10 w-10 items-center justify-center rounded-control bg-primary-100 text-primary-600">
				<Icon className="h-5 w-5" />
			</div>
		)}
		<h3 className="text-sm font-semibold text-text">{title}</h3>
		{description && <p className="mt-1 max-w-md text-sm text-bgBase-800">{description}</p>}
		{action && <div className="mt-4">{action}</div>}
	</div>
);

EmptyState.propTypes = {
	icon: PropTypes.elementType,
	title: PropTypes.string.isRequired,
	description: PropTypes.node,
	action: PropTypes.node,
	className: PropTypes.string,
};

export default EmptyState;
